module.exports = __webpack_public_path__ + "RxZJdnzeo3R5zSexge8UUT8E0i7KZn-EPnyo3HZu7kw.57af64fc644194101c15.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto/RxZJdnzeo3R5zSexge8UUT8E0i7KZn-EPnyo3HZu7kw.woff
// module id = 782
// module chunks = 1